import { render, staticRenderFns } from "./normal-picture-selector.vue?vue&type=template&id=df9eb7f6&scoped=true"
import script from "./normal-picture-selector.vue?vue&type=script&lang=js"
export * from "./normal-picture-selector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df9eb7f6",
  null
  
)

export default component.exports